<script>

import { onMount, onDestroy } from 'svelte';

import { account_service       , account_service_context_key        } from './_services/account.js';
import { loggedIn                                                   } from './_services/accountsession.js';

</script>


<style>

	h1 {color: purple;}
	
.about_avatar  {
  width: 300px;
  height: 300px;
  border-radius: 50%;
  border: 0px solid black;
}	

</style>


<h1>About</h1>
<img src="../assets/Wdsck5M7Qs47yOcY.jpg" class="about_avatar" alt="avatar">